import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Link } from "react-router-dom";
import { Button } from "./ui/button";
import { Badge } from "./ui/badge";
import { Target, ArrowRight, CheckCircle2 } from "lucide-react";

// Dashboard insight card: share of material metrics that already have a baseline set.
export default function BaselineReadinessCard() {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/baseline/readiness").then((r) => setD(r.data)).catch(() => {}); }, []);
  if (!d) return null;

  const pct = d.pct || 0;
  const done = d.material_total > 0 && d.material_with_baseline >= d.material_total;
  const shown = d.missing || [];

  return (
    <div className="card-flat p-5" data-testid="baseline-readiness-card">
      <div className="flex items-start justify-between gap-3">
        <div className="inline-flex items-center gap-2">
          <div className="h-8 w-8 rounded-sm bg-accent/10 border border-accent/20 grid place-items-center"><Target className="h-4 w-4 text-accent" /></div>
          <div>
            <div className="font-display font-semibold text-sm">Baseline readiness</div>
            <div className="text-[11px] text-muted-foreground">{d.baseline_year ? `Reference year FY${d.baseline_year}` : "No baseline year set"}</div>
          </div>
        </div>
        <Badge variant={done ? "success" : pct >= 50 ? "lime" : "warning"} className="text-xs font-mono" data-testid="baseline-readiness-pct">{pct}%</Badge>
      </div>

      <div className="mt-3 h-2 rounded-full bg-surface overflow-hidden">
        <div className="h-full bg-accent transition-all" style={{ width: `${pct}%` }} data-testid="baseline-readiness-bar" />
      </div>
      <div className="mt-1.5 text-[11px] text-muted-foreground">
        <span className="text-foreground font-medium">{d.material_with_baseline}</span> of {d.material_total} material metrics baselined
      </div>

      {d.missing_total > 0 ? (
        <div className="mt-3">
          <div className="label-eyebrow text-[10px] mb-1.5">Still missing real data</div>
          <div className="flex flex-wrap gap-1.5">
            {shown.map((m) => (
              <Badge key={m.metric_key} variant="outline" className="text-[10px]" data-testid="baseline-missing-chip">{m.name}</Badge>
            ))}
            {d.missing_total > shown.length && <Badge variant="outline" className="text-[10px]">+{d.missing_total - shown.length} more</Badge>}
          </div>
        </div>
      ) : (
        <div className="mt-3 inline-flex items-center gap-1.5 text-[11px] text-[#00E65B]"><CheckCircle2 className="h-3.5 w-3.5" /> All material metrics have a baseline.</div>
      )}

      <Link to="/baseline" className="block mt-3">
        <Button variant="outline" size="sm" className="w-full" data-testid="baseline-readiness-open">Open Baseline Wizard <ArrowRight className="h-3.5 w-3.5" /></Button>
      </Link>
    </div>
  );
}
